import { type EndpointBody, getEndpointUrl } from 'api';
import type {
	ProductArchiveFacetType,
	ProductArchiveSearchResponse,
	ProductArchiveSortOption,
} from 'models/api';
import type { CategoryId } from 'types';
import { exhaustiveArray } from 'utils/collection';
import { is } from 'utils/helpers';

import usePagedData from './usePagedData';

const facetTypes = exhaustiveArray<ProductArchiveFacetType>()(
	'Brand',
	'Category',
);

export default function useProductArchiveSearch(
	queryParams: {
		categoryId?: CategoryId;
		searchString?: string;
		sortOption?: ProductArchiveSortOption;
	},
	facets: Record<ProductArchiveFacetType, string | undefined>,
	isActive: boolean,
) {
	const body = facetTypes
		.map((type) =>
			facets[type] ? { facetType: type, selected: [facets[type]] } : null,
		)
		.filter(is.truthy) satisfies EndpointBody<'PostSearchProductArchive'>;

	return usePagedData<ProductArchiveSearchResponse, 'products'>({
		baseUrl: getEndpointUrl({
			name: 'PostSearchProductArchive',
			queryParams,
		}),
		itemsKey: 'products',
		isActive,
		pageSize: 10,
		method: 'POST',
		body,
	});
}
